import { render, staticRenderFns } from "./Nevres1.vue?vue&type=template&id=52ed685a&"
import script from "./Nevres1.vue?vue&type=script&lang=js&"
export * from "./Nevres1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports